import { useState } from 'react'
import {
  Box,
  Grid,
} from '@mui/material'
import { useForm, FormProvider } from 'react-hook-form'
import { CPT } from 'types/types/Types'
import RVUsCalculatorSection from './RVUsCalculatorSection'
import RVUsResultSection from './RVUsResultSection'

interface RVUFormValues {
  cpts: CPT[]
}

export default function RVUsCalculator() {
  const [calculatedCPTs, setCalculatedCPTs] = useState<any[]>([])

  const methods = useForm<RVUFormValues>({
    defaultValues: {
      cpts: Array.from({ length: 8 }).map(() => ({
        id: undefined,
        code: '',
        value: '',
        rvu_value: 0,
        quantity: undefined,
      })),
    },
  })

  const { handleSubmit } = methods

  const onSubmit = (data: RVUFormValues) => {
    const results = data.cpts
      .filter(cpt => cpt?.code && cpt?.quantity)
      .map(cpt => {
        const rvuPerUnit = Number(cpt.rvu_value || 0)
        const quantity = Number(cpt.quantity || 0)

        return {
          ...cpt,
          rvuPerUnit,
          totalRVUs: rvuPerUnit * quantity,
        }
      })

    setCalculatedCPTs(results)
  }

  return (
    <FormProvider {...methods}>
      
      <Box component="form" onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2}>

          {/* LEFT: RVU Calculator */}
          <RVUsCalculatorSection />

          {/* RIGHT: Result */}
          <RVUsResultSection calculatedCPTs={calculatedCPTs} />

        </Grid>
      </Box>

      <Box my={3} />
    </FormProvider>
  )
}
